import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as proposal from '../proposal'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: proposal.RESOURCE.payload.dimension.partialId,
      partialId: proposal.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'Value propositions presented by this proposal',
    isOptional: true,
    name: 'Value Propositions',
    partialId: PartialId.Standard.create('value_propositions'),
    type: core.common.value.types.Intrinsic.Text,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
